import { Modal } from "antd";
import { useState, useEffect } from "react";
import { CheckCircleOutlined, ExclamationCircleOutlined, ShoppingOutlined, TruckOutlined } from "@ant-design/icons";

export const OpenRestaurantModal = ({ onOpen, restaurantOpenState }) => {
  const modalKey = "open-restaurant-modal-prompt-flag";
  const hasBeenShown = sessionStorage.getItem(modalKey) === "shown";
  const [openModal, setOpenModal] = useState(!hasBeenShown);

  useEffect(() => {
    if (!hasBeenShown) {
      setOpenModal(true);
    }
  }, []);

  const handleCancel = () => {
    setOpenModal(false);
    sessionStorage.setItem(modalKey, "shown");
  };

  const handleOpen = () => {
    onOpen(true);
    setOpenModal(false);
    sessionStorage.setItem(modalKey, "shown");
  };

  return (
    <Modal
      open={openModal}
      footer={false}
      onCancel={handleCancel}
      className=""
    >
      {restaurantOpenState ? (
        <div className="flex flex-col justify-center mt-8 items-center">
          {/* <div className="mb-6">
            <CheckCircleOutlined style={{ fontSize: "64px", color: "#22c55e" }} />
          </div> */}
          <h2 className="text-3xl font-bold text-center mb-2 text-green-600">
            Restaurant is Open
          </h2>
          <p className="text-xl text-gray-600 text-center mb-8">
            You're ready to accept orders!
          </p>

          <div className="w-full bg-green-50 border border-green-200 rounded-lg p-6 mb-6">
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <ShoppingOutlined style={{ fontSize: "24px", color: "#16a34a", marginTop: "4px" }} />
                <div>
                  <h4 className="font-semibold text-gray-900 text-xl">Check Opening Stock</h4>
                  <p className="text-lg text-gray-700 mt-1">Verify inventory levels to avoid running out of items during peak hours</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <TruckOutlined style={{ fontSize: "24px", color: "#16a34a", marginTop: "4px" }} />
                <div>
                  <h4 className="font-semibold text-gray-900 text-xl">Alert Your Delivery Team</h4>
                  <p className="text-lg text-gray-700 mt-1">Notify your delivery personnel to be on standby for incoming orders</p>
                </div>
              </div>
            </div>
          </div>

          <button
            className="rounded-lg font-semibold bg-green-600 hover:bg-green-700 text-white px-8 py-3 transition"
            onClick={handleCancel}
          >
            Got it
          </button>
        </div>
      ) : (
        <div className="flex flex-col justify-center mt-8 items-center">
          {/* <div className="mb-6">
            <ExclamationCircleOutlined style={{ fontSize: "64px", color: "#ef4444" }} />
          </div> */}
          <h2 className="text-3xl font-bold text-center mb-2 text-red-600">
            Restaurant is Closed
          </h2>
          <p className="text-xl text-gray-600 text-center mb-8">
            You're not accepting orders right now
          </p>

          <div className="w-full bg-red-50 border border-red-200 rounded-lg p-6 mb-6 space-y-4">
            <div className="flex items-start gap-4">
              <ExclamationCircleOutlined style={{ fontSize: "20px", color: "#dc2626", marginTop: "4px" }} />
              <div>
                <h4 className="font-semibold text-gray-900 text-xl">No Items = Not Visible</h4>
                <p className="text-lg text-gray-700 mt-1">The system won't display your restaurant if you have no menu items</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <ExclamationCircleOutlined style={{ fontSize: "20px", color: "#dc2626", marginTop: "4px" }} />
              <div>
                <h4 className="font-semibold text-gray-900 text-xl">Add Menu Items First</h4>
                <p className="text-lg text-gray-700 mt-1">Go to "My Items" and add at least one item before opening</p>
              </div>
            </div>
          </div>

          <button
            className="rounded-lg font-semibold bg-green-600 hover:bg-green-700 text-white px-8 py-3 transition"
            onClick={handleOpen}
          >
            Open Restaurant
          </button>
        </div>
      )}
    </Modal>
  );
};
